export default __webpack_public_path__ + "static/fa-regular-400-7a3337626410ca2f40718481c755640f.woff2";